import React, { Component, useState, useEffect } from "react";
import {
  login,
  getUser,
} from "../../Model/Content"; //Include Home
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import * as ErrCodes from "../../Config/ErrorCode.js";
import {
  BrowserRouter as Router,
  Routes,
  useParams,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { SVGIcons, ImgIcons, VirsionCheck } from "../../Helpers/Common";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Paymentsuccess(props) {

  var Qeuryparameters = new URLSearchParams(window.location.search)
  const navigate = useNavigate();
  var erro = Qeuryparameters.get('error')
  
  function closebtn(){
    navigate("/");
  }

  return (
          <>
            <motion.div
              className=""
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
              key="1"
            >
              <div className="notification-box">
                  <div className="passChangepopup" id="passChange" style={{display: 'flex'}}>
                    <div className="temp31-modal-body popup-animation">
                      <button className="temp31-modal-close temp31-modal-toggle"><img src={SVGIcon['promocode-close.svg']} alt="DocuBay" onClick={()=>{
                        closebtn();
                      }}/></button>
                      <img src={ImageData['payment-succes.png']} alt="DocuBay" className="imgPass" style={{height: '80px'}} />
                      <div className="temp31-awesome">
                        <h5>Payment successfully</h5>
                      </div>
                    </div>
                  </div> 
                <Mobilemenu active="1" />
              </div>
            </motion.div>
          </>
        );
  

}
